export const LAZY_BUNDLES: Record<string, () => Promise<unknown>> = {
  // health-audit-bundle
  HealthAuditPage: () => import('../../../entrypoints/health-audit-bundle'),

  // user-bundle
  ComparePage: () => import('../../../entrypoints/user-bundle'),
  GrowthProfilePage: () => import('../../../entrypoints/user-bundle'),
  UserSettings: () => import('../../../entrypoints/user-bundle'),

  // org-bundle
  InsightsEngagementPage: () => import('../../../entrypoints/org-bundle'),
  InsightsSkillsPage: () => import('../../../entrypoints/org-bundle'),
  OrgPeoplePage: () => import('../../../entrypoints/org-bundle'),
  OrgPreferencesPage: () => import('../../../entrypoints/org-bundle'),
  CheckinSettingsPage: () => import('../../../entrypoints/org-bundle'),
  PerformanceCyclesPage: () => import('../../../entrypoints/org-bundle'),

  // framework-page-bundle
  FrameworkPage: () => import('../../../entrypoints/framework-page-bundle'),
  FrameworkPageAssistant: () =>
    import('../../../entrypoints/framework-page-bundle'),

  // reflections-bundle
  ReflectionsNewPage: () => import('../../../entrypoints/reflections-bundle'),
  ReflectionsShowPage: () => import('../../../entrypoints/reflections-bundle'),
  ReflectionsIndexPage: () => import('../../../entrypoints/reflections-bundle'),

  // stories-bundle
  StoriesPage: () => import('../../../entrypoints/stories-bundle'),
  StoryPage: () => import('../../../entrypoints/stories-bundle'),

  // first-90-days-bundle
  First90DaysPage: () => import('../../../entrypoints/first-90-days-bundle'),

  // framework-builder-bundle
  FrameworkBuilder: () =>
    import('../../../entrypoints/framework-builder-bundle'),
}
